<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>1-search</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-1241.000000, -25.000000)" fill="#000000">
        <g transform="translate(1241.000000, 25.000000)">
          <path
            d="M8.1,1.78615385 C4.620609,1.78615385 1.8,4.58506585 1.8,8.03769231 C1.8,11.4903277 4.620609,14.2892308 8.1,14.2892308 C9.83997,14.2892308 11.41371,13.5904874 12.55473,12.4581552 C13.69584,11.3259122 14.4,9.76427792 14.4,8.03769231 C14.4,4.58506585 11.5794,1.78615385 8.1,1.78615385 Z M0,8.03769231 C0,3.59859988 3.626496,0 8.1,0 C12.57354,0 16.2,3.59859988 16.2,8.03769231 C16.2,9.93512354 15.53652,11.6800172 14.42871,13.0546412 L19.53639,18.1231207 C19.88784,18.4718672 19.88784,19.0373635 19.53639,19.3861101 C19.18494,19.7348566 18.61506,19.7348566 18.26361,19.3861101 L13.15584,14.3177199 C11.77056,15.4170083 10.01214,16.0753846 8.1,16.0753846 C3.626496,16.0753846 0,12.4768205 0,8.03769231 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "search-icon",
};
</script>
